export const HIDE_BOTTOM_SERVICE_MODE_ROUTES: string[] = [
  '/menu/picker-',
  '/menu/combo-',
  '/menu/item-',
];
